export const SET_COMPLETED_TRANSACTION_ITEMS = "SET_COMPLETED_TRANSACTION_ITEMS"